import { createRouter, createWebHistory } from 'vue-router';
import Login from '../components/Log_in.vue'; 
import HomeComponent from '../components/home_component.vue'; 
import PosComponent from '../components/pos_component.vue'; 
import CategoriesComponent from '../components/categories_component.vue'; 
import UserComponent from '../components/add_user.vue'; 
import UsersComponent from '../components/users_component.vue'; 
import UpdateUsersComponent from '../components/update_user.vue'; 
import AddCatComponent from '../components/add_cat.vue'; 
import PermissionsComponent from '../components/permissions_component.vue'; 
import BranchesComponent from '../components/branches_component.vue'; 
import AddBrancheComponent from '../components/add_branch_component.vue'; 
import EditBrancheComponent from '../components/update_branch_component.vue'; 
import EditCategoryComponent from '../components/update_category_component.vue'; 
import CatProductsComponent from '../components/cat_products_component.vue'; 
import AddProductComponent from '../components/add_product_component.vue'; 
import EditProductComponent from '../components/edit_product_component.vue'; 
import TaxProductComponent from '../components/tax_component.vue'; 
import AddTaxProductComponent from '../components/add_tax_component.vue'; 
import EditTaxProductComponent from '../components/edit_tax_component.vue'; 
import AddCustomProductComponent from '../components/add_custom_component.vue'; 
import CustomProductComponent from '../components/customization_component.vue'; 
import EditCustomProductComponent from '../components/edit_custom_component.vue'; 
import CustomersComponent from '../components/customers_component.vue'; 
import AddCustomerComponent from '../components/add_customer_component.vue'; 
import EditCustomerComponent from '../components/edit_customer_component.vue'; 
import DeliverCompamiesComponent from '../components/delivery_companies_component.vue'; 
import AddDeliverCompamiesComponent from '../components/add_delivery_component.vue'; 
import EditDeliverCompamiesComponent from '../components/edit_delivery_company.vue'; 
import DriversCompamiesComponent from '../components/drivers_component.vue'; 
import AddDriverCompamiesComponent from '../components/add_driver_component.vue'; 
import EditDriverCompamiesComponent from '../components/edit_driver_component.vue'; 
import WaitersComponent from '../components/waiters_component.vue'; 
import AddWaiterComponent from '../components/add_waiter_component.vue'; 
import EditWaiterComponent from '../components/edit_waiter_component.vue'; 
import DeliveryComponent from '../components/delivery_component.vue'; 
import TakeawayComponent from '../components/takeaway_component.vue'; 
import DineinComponent from '../components/dinein_component.vue'; 
import DeliveryLocComponent from '../components/delivery_process_component.vue'; 
import DriverpopupLocComponent from '../components/drivers_popup_component.vue'; 
import TablePopupComponent from '../components/table_details_component.vue'; 
import GenReportsComponent from '../components/GenReports.vue'; 
import TablesComponent from '../components/tables_component.vue'; 
import FindComponent from '../components/find_customer_component.vue'; 
import ReportsComponent from '../components/show_reports_components.vue'; 
import CustomersAccComponent from '../components/customers_account_component.vue'; 
import CustomersmanageComponent from '../components/manage_customers_component.vue'; 
import EditAccComponent from '../components/edit_customer_acc_component.vue'; 
import LogsComponent from '../components/logs_component.vue'; 
import BackgroundColorComponent from '../components/background_update_component.vue'; 
import ShowInvoiceComponent from '../components/show_invoices_component.vue'; 
import MergeTableComponent from '../components/merge_table_component.vue'; 
import SplitTableComponent from '../components/split_table_component.vue'; 
import BillsComponent from '../components/bills_component.vue'; 
import PaymentsComponent from '../components/RecordPayment_component.vue'; 
import LanguageComponent from '../components/language_component.vue'; 
import AddLanguageComponent from '../components/add_language_component.vue'; 
import EditLanguageComponent from '../components/edit_language_component.vue'; 
import BarcodeSegmentation from '../components/barcode_component.vue'; 
import EditPrinterComponent from '../components/EditPrinterComponent.vue'; 
import AddPrinterComponent from '../components/AddPrinterComponent.vue'; 
import PrintersManagement from '../components/PrintersManagement.vue'; 
import PosSettings from '../components/pos_settings.vue'; 
import FloorsSettings from '../components/floors_settings.vue'; 
import PrintComponent from '../components/print_order_component.vue'; 
import PaymentPage from '../components/PaymentPage.vue'; 

import FloorComponent from '../components/floors_component.vue'; 
import EditFloorPage from '../components/EditFloorComponent.vue'; 
import AddFloorComponent from '../components/AddFloorComponent.vue'; 
import SettingsComponent from '../components/Settings_Component.vue'; 
import ShiftsComponent from '../components/ShiftsComponent.vue'; 

const routes = [
  {
  path: '/',
  redirect: '/home'
  },
  {
  path: '/payment-page/:orderId',
  name: 'PaymentPage',
  component: PaymentPage, 

  meta: { public: true }
},
{
    path: '/floors',
    name: 'Floors',
    component: FloorComponent,
    meta: { requiresAuth: true }
},
{
    path: '/floors/add',
    name: 'AddFloorComponent',
    component: AddFloorComponent,
    meta: { requiresAuth: true }
},
{
    path: '/floors/edit/:id',
    name: 'EditFloorPage',
    component: EditFloorPage,
    meta: { requiresAuth: true }
},
  {
    path: '/login', 
    name: 'Login',
    component: Login, 
    meta: { guestOnly: true } 
  },
 {
  path: '/print/:tableId/:appId/:branchId', 
  name: 'Print',
  component: PrintComponent, 
  meta: { 
    public: true,
  }
},
  {
    path: '/loginwaiter', 
    name: 'LoginWaiter',
    component: Login, 
  },
    {
    path: '/shifts', 
    name: 'ShiftsComponent',
    component: ShiftsComponent, 
  },
    {
    path: '/settings', 
    name: 'settings',
    component: SettingsComponent, 
  },
  {
    path: '/home', 
    name: 'HomeComponent',
    component: HomeComponent,
    meta: { requiresAuth: true }  
  },
  {
    path: '/pos/:orderId?/:tableId?/:showmodal?',
    name: 'PosComponent',
    component: PosComponent, 
    meta: { requiresAuth: true }
  },
  {
    path: '/addUser', 
    name: 'UserComponent',
    component: UserComponent, 
  },
  {
    path: '/categories', 
    name: 'CategoriesComponent',
    component: CategoriesComponent, 
  },
  {
    path: '/users', 
    name: 'UsersComponent',
    component: UsersComponent, 
  },
  {
    path: '/edituser/:id', 
    name: 'UpdateUsersComponent',
    component: UpdateUsersComponent, 
  },
  {
    path: '/permissons/:id', 
    name: 'PermissionsComponent',
    component: PermissionsComponent, 
  },
  {
    path: '/addcat', 
    name: 'AddCatComponent',
    component: AddCatComponent, 
  },
  {
    path: '/branches', 
    name: 'BranchesComponent',
    component: BranchesComponent, 
  },
  {
    path: '/addbranch', 
    name: 'AddBrancheComponent',
    component: AddBrancheComponent, 
  },
  {
    path: '/editbranch/:id', 
    name: 'EditBrancheComponent',
    component: EditBrancheComponent, 
  },
  {
    path: '/editcat/:id', 
    name: 'EditCategoryComponent',
    component: EditCategoryComponent, 
  },
  {
    path: '/catproducts/:id', 
    name: 'CatProductsComponent',
    component: CatProductsComponent, 
  },
  {
    path: '/addproduct/:id', 
    name: 'AddProductComponent',
    component: AddProductComponent, 
  },
  {
    path: '/editproduct/:id', 
    name: 'EditProductComponent',
    component: EditProductComponent, 
  },
  {
    path: '/tax/:id/:name', 
    name: 'TaxProductComponent',
    component: TaxProductComponent, 
  },
  {
    path: '/addtax/:id', 
    name: 'AddTaxProductComponent',
    component: AddTaxProductComponent, 
  },
  {
    path: '/edittax/:id', 
    name: 'EditTaxProductComponent',
    component: EditTaxProductComponent, 
  },
  {
    path: '/addcustom/:id/:price', 
    name: 'AddCustomProductComponent',
    component: AddCustomProductComponent, 
  },
  {
    path: '/editcustom/:id/:price', 
    name: 'EditCustomProductComponent',
    component: EditCustomProductComponent, 
  },
  {
    path: '/customization/:id/:price', 
    name: 'CustomProductComponent',
    component: CustomProductComponent, 
  },
  {
    path: '/customers', 
    name: 'CustomersComponent',
    component: CustomersComponent, 
  },
  {
    path: '/addcustomer', 
    name: 'AddCustomerComponent',
    component: AddCustomerComponent, 
  },
  {
    path: '/editcustomer/:id', 
    name: 'EditCustomerComponent',
    component: EditCustomerComponent, 
  },
  {
    path: '/delivery_companies', 
    name: 'DeliverCompamiesComponent',
    component: DeliverCompamiesComponent, 
  },
  {
    path: '/add_delivery_comp', 
    name: 'AddDeliverCompamiesComponent',
    component: AddDeliverCompamiesComponent, 
  },
  {
    path: '/edit_delivery_comp/:id', 
    name: 'EditDeliverCompamiesComponent',
    component: EditDeliverCompamiesComponent, 
  },
  {
    path: '/drivers', 
    name: 'DriversCompamiesComponent',
    component: DriversCompamiesComponent, 
  },
  {
    path: '/adddriver', 
    name: 'AddDriverCompamiesComponent',
    component: AddDriverCompamiesComponent, 
  },
  {
    path: '/edit_driver/:id', 
    name: 'EditDriverCompamiesComponent',
    component: EditDriverCompamiesComponent, 
  },
  {
    path: '/waiters', 
    name: 'WaitersComponent',
    component: WaitersComponent, 
  },
  {
    path: '/addwaiter', 
    name: 'AddWaiterComponent',
    component: AddWaiterComponent, 
  },
  {
    path: '/edit_waiter/:id', 
    name: 'EditWaiterComponent',
    component: EditWaiterComponent, 
  },
  {
    path: '/delivery', 
    name: 'DeliveryComponent',
    component: DeliveryComponent, 
  },
  {
    path: '/takeaway', 
    name: 'TakeawayComponent',
    component: TakeawayComponent, 
  },
  {
    path: '/dinein', 
    name: 'DineinComponent',
    component: DineinComponent, 
  },
  {
    path: '/delivery_loc', 
    name: 'DeliveryLocComponent',
    component: DeliveryLocComponent, 
  },
  {
    path: '/driverpopup', 
    name: 'DriverpopupLocComponent',
    component: DriverpopupLocComponent, 
  },
  {
    path: '/tablepopup', 
    name: 'TablePopupComponent',
    component: TablePopupComponent, 
  },
  {
    path: '/tables', 
    name: 'TablesComponent',
    component: TablesComponent, 
  },
  {
    path: '/findcustomer', 
    name: 'FindComponent',
    component: FindComponent, 
  },
  {
    path: '/reports', 
    name: 'ReportsComponent',
    component: ReportsComponent, 
  },
  {
    path: '/genreports/:listname', 
    name: 'GenReportsComponent',
    component: GenReportsComponent, 
  },
  {
    path: '/customersAcc', 
    name: 'CustomersAccComponent',
    component: CustomersAccComponent, 
  },
  {
    path: '/managecustomers', 
    name: 'CustomersmanageComponent',
    component: CustomersmanageComponent, 
  },
  {
    path: '/editAcc/:customerId', 
    name: 'EditAccComponent',
    component: EditAccComponent, 
  },
    {
    path: '/logs', 
    name: 'LogsComponent',
    component: LogsComponent, 
  },
      {
    path: '/colorchange', 
    name: 'BackgroundColorComponent',
    component: BackgroundColorComponent, 
  },
    {
    path: '/showinvoice/:id', 
    name: 'ShowInvoiceComponent',
    component: ShowInvoiceComponent, 
  },
     {
    path: '/mergetable/:orderId?/:tableId?', 
    name: 'MergeTableComponent',
    component: MergeTableComponent, 
  },
       {
    path: '/splittable/:orderId?', 
    name: 'SplitTableComponent',
    component: SplitTableComponent, 
  },
         {
    path: '/bills', 
    name: 'BillsComponent',
    component: BillsComponent, 
  },
    {
    path: '/payments/:customerId', 
    name: 'PaymentsComponent',
    component: PaymentsComponent, 
  },
    {
    path: '/languages', 
    name: 'LanguageComponent',
    component: LanguageComponent, 
  },
      {
    path: '/addlang', 
    name: 'AddLanguageComponent',
    component: AddLanguageComponent, 
  },
    {
    path: '/editlang/:id', 
    name: 'EditLanguageComponent',
    component: EditLanguageComponent, 
    
  },
      {
    path: '/barcode/:id', 
    name: 'BarcodeSegmentation',
    component: BarcodeSegmentation, 
    
  },
  {
  path: '/printers',
  name: 'PrintersManagement',
  component: PrintersManagement,
  meta: { requiresAuth: true }
},
{
  path: '/printers/add',
  name: 'AddPrinterComponent',
  component: AddPrinterComponent,
  meta: { requiresAuth: true }
},
{
  path: '/printers/edit/:id',
  name: 'EditPrinterComponent',
  component: EditPrinterComponent,
  meta: { requiresAuth: true }
},
{
  path: '/pos_settings',
  name: 'PosSettings',
  component: PosSettings,
  meta: { requiresAuth: true }
},
{
  path: '/floors_settings',
  name: 'FloorsSettings',
  component: FloorsSettings,
  meta: { requiresAuth: true }
}
];

const router = createRouter({
  history: createWebHistory('/viamenu/'),
  routes,
});
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('authToken')
  const isAuthenticated = !!token

  // Handle root path redirect
  if (to.path === '/viamenu/' || to.path === '/viamenu') {
    return isAuthenticated 
      ? next({ name: 'HomeComponent' })
      : next({ name: 'Login' })
  }

  // 1. First check for public routes
  if (to.matched.some(record => record.meta.public)) {
    return next() // Always allow access
  }

  // 2. Then check for auth-required routes
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!isAuthenticated) {
      return next({
        name: 'Login',
        query: { redirect: to.fullPath }
      })
    }
    return next()
  }

  // 3. Then check for guest-only routes
  if (to.matched.some(record => record.meta.guestOnly)) {
    if (isAuthenticated) {
      return next({ name: 'HomeComponent' })
    }
    return next()
  }

  // 4. Default case - allow access
  next()
})
export default router;

